<template>
  <div class="bbe-folder-form">
    <transition name="bbe-fade" appear>
      <loader-fly v-if="loaderRun"/>
    </transition>
    <label>
      <span class="bbe-folder-form__title">
        Folder name
      </span>
      <input class="bbe-input bbe-input_border"
             v-autofocus
             v-model="folder.name"
             @keyup.enter="rightButtonAction()"
             type="text"/>
    </label>
    <div v-if="isEmployeeFolder">
      <span class="bbe-folder-form__title">
        Personal For
      </span>
    <div class="bbe-folder-form-select" v-if="userListMail.length > 0">
      <v-select :components="{OpenIndicator}"
                label="username"
                :disabled="typeFolder !== 2"
                :options="userListMail"
                :placeholder="'Select user'"
                :clearable="false"
                :value="userSelected.username ? userSelected : ''"
                @search="searchUser"
                @input="setUser">
        <template #selected-option="option">
          <div class="bbe-folder-form-select-selected" v-if="option.username">
            <div class="bbe-folder-form-select-selected-avatar">
              <img class="bbe-folder-form-select-selected-avatar__image"
                   :src="option.image.path"
                   v-if="option.image && option.image.path"/>
              <i class="email-icon-user bbe-folder-form-select-selected-avatar__icon" v-else/>
            </div>
            <div class="bbe-folder-form-select-selected__name">{{option.username}}</div>
            <div class="bbe-folder-form-select-selected__email">{{option.email}}</div>
          </div>
        </template>
        <template #option="option">
          <div class="bbe-folder-form-select-item" v-if="Object.keys(option).length !== 0">
            <div class="bbe-folder-form-select-item-avatar">
              <img class="bbe-folder-form-select-item-avatar__image"
                   :src="option.image.path"
                   v-if="option.image && option.image.path"/>
              <i class="email-icon-user bbe-folder-form-select-item-avatar__icon" v-else/>
            </div>
            <div class="bbe-folder-form-select-item__name">{{option.username}}</div>
            <div class="bbe-folder-form-select-item__email">{{option.email}}</div>
          </div>
        </template>
      </v-select>
    </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import {get, set, orderBy, omitBy} from 'lodash'
import UsersApi from '@/api/Users/api'
import folderTypes from '@/constants/folderTypes'
import LoaderFly from '@/components/Main/Loaders/LoaderFly'

export default {
  name: 'NewFolderForm',
  props: ['folder', 'rightAction', 'parentFolder'],
  components: {
    vSelect,
    LoaderFly
  },
  data () {
    return {
      loaderRun: false,
      userSelected: {},
      OpenIndicator: {
        render: createElement => createElement('span', {class: {'bbe-folder-form-select__toggle': true}})
      }
    }
  },
  computed: {
    isEmployeeFolder () {
      const typeParentFolder = get(this.parentFolder, 'typeFolder', '')
      return typeParentFolder === folderTypes.EMPLOYEE_FOLDER
    },
    typeFolder () {
      const sharedFolder = 1
      const personalFolder = 2
      return this.isEmployeeFolder ? personalFolder : sharedFolder
    },
    userListMail: {
      get () {
        return this.$store.getters.userListMail
      },
      set (data) {
        this.$store.dispatch('setUserListMail', data)
      }
    }
  },
  methods: {
    searchUser (word) {
      if (!word) {
        this.userListMail = orderBy(this.userListMail, ['username'], ['asc'])
      } else {
        const reg = new RegExp('^' + word, 'gmi')
        this.userListMail = this.userListMail.sort((a, b) => {
          return reg.test(b.username) - reg.test(a.username)
        })
      }
    },
    setUser (item) {
      this.userSelected = item || {}
      const userId = get(item, 'id', '')
      if (userId) {
        set(this.folder, 'userCreateFolder', userId)
      } else {
        omitBy(this.folder, item => !item)
      }
    },
    rightButtonAction () {
      if (typeof this.rightAction === 'function') this.rightAction()
    },
    getUserList () {
      this.loaderRun = true
      UsersApi.getUsersList({})
        .then(resp => {
          this.userListMail = get(resp, 'data.users', [])
          this.setUser(this.userListMail[0])
          this.loaderRun = false
        })
        .catch(err => {
          console.error(err)
          this.loaderRun = false
        })
    },
    checkUserList () {
      this.loaderRun = true
      UsersApi.getUsersList({limit: 1})
        .then(resp => {
          const alreadyUsersLength = get(this.userListMail, 'length', 0)
          const allUsersLength = get(resp, 'data.totalDocs', 0)
          if (alreadyUsersLength !== allUsersLength) {
            this.getUserList()
          } else {
            this.loaderRun = false
            this.setUser(this.userListMail[0])
          }
        })
        .catch(err => {
          this.loaderRun = false
          console.error(err)
        })
    }
  },
  beforeMount () {
    if (this.isEmployeeFolder) this.checkUserList()
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../sass/variables";
@import "../../../../sass/mixins";

.bbe-folder-form {
  display: grid;
  grid-gap: 18px;
  margin: 33px 18px 41px;

  &__title {
    display: inline-block;
    color: $color-silver-chalice;
    font-size: 12px;
    line-height: 14px;
    margin-bottom: 8px;
  }
}

</style>

<style lang="scss">
@import "../../../../sass/variables";
@import "../../../../sass/mixins";

.bbe-folder-form {
  &-select {
    font-size: 12px;
    line-height: 14px;

    &-item {
      display: grid;
      grid-gap: 1px 12px;
      grid-template-columns: 36px 1fr;
      grid-template-rows: 1fr 1fr;
      padding: 6px 12px;
      transition: 0.3s;

      &:hover {
        background-color: $color-gallery;
      }

      &-avatar {
        grid-row: 1/3;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 36px;
        height: 36px;
        border-radius: 50%;
        overflow: hidden;

        &__image {
          width: 100%;
          height: auto;
          object-fit: cover;
        }

        &__icon {
          font-size: 36px;
          color: $color-accent;
        }
      }

      &__name {
        color: $color-black;
        text-transform: capitalize;
      }

      &__email {
        font-size: 11px;
        color: $color-silver-chalice
      }
    }

    &-selected {
      display: grid;
      align-items: center;
      grid-gap: 10px;
      grid-template-columns: 22px auto auto;

      &-avatar {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 22px;
        height: 22px;
        border-radius: 50%;
        overflow: hidden;

        &__image {
          width: 100%;
          height: auto;
          object-fit: cover;
        }

        &__icon {
          font-size: 21px;
          color: $color-accent;
        }
      }

      &__name {
        text-transform: capitalize;
        color: $color-black;
      }

      &__email {
        font-size: 11px;
        color: $color-silver-chalice
      }
    }

    &__toggle {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 24px;
      height: 24px;
      transition: .2s;

      &:after {
        font-family: "fontello-email", serif;
        content: '\E813';
        font-size: 12px;
        margin-left: 1px;
        color: $color-silver-chalice;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Templates/TemplatesSidebar/FolderForm/NewFolderForm.vue